import { render } from "./DocAccordion.vue?vue&type=template&id=79bf9c67"
import script from "./DocAccordion.vue?vue&type=script&lang=js"
export * from "./DocAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__